import styled from 'styled-components';
import { InfoCardMiniSpan } from '../../../CardInputs/CardsStyledComponents';

export const CardContainer = styled.div`
    display: flex;
    width: 100%;
    padding: 24px;
    background-color: #fff;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.colors.gray11};
    cursor: pointer;
`;

export const CardColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
    margin-left: 8px;
`;

export const CardRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
`;

export const CardSectionColumn = styled(CardColumn)`
    gap: 4px;
    margin: 0;
`;


export const CardColumnArrow = styled(CardColumn)`
    width: 24px;
    justify-content: center;
`;

export const InfoCardPaymentPlan = styled(InfoCardMiniSpan)`

`;